<template>
  <div>
    <v-btn
      v-if="currency == 'PKR'"
      class="ma-2"
      outline
      color="orange"
      :disabled="status == 1 || status == -1 || customerStatus == 'view'"
      @click="check()"
    >
      + Add Shipment Document
    </v-btn>
    <v-btn
      v-else
      class="ma-2"
      outline
      color="orange"
      :disabled="
        status == 1 ||
        status == 3 ||
        status == 4 ||
        status == -1 ||
        customerStatus == 'view'
      "
      @click="check()"
    >
      + Add Shipment Document
    </v-btn>
    <v-dialog
      v-model="dialog"
      max-width="52rem"
      persistent
      content-class="job-documents-dialog shipment-upload-dialog"
    >
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-card class="job-documents-dialog-card shipment-upload-card">
          <header class="shipment-upload-header">
            <h2 class="shipment-upload-title">Shipment Documents</h2>
            <v-btn
              icon
              class="shipment-upload-close"
              title="Close"
              @click.prevent="closeDialog()"
            >
              <v-icon>close</v-icon>
            </v-btn>
          </header>
          <v-progress-linear
            indeterminate
            color="yellow darken-2"
            v-show="loading"
          ></v-progress-linear>
          <v-card-text class="shipment-upload-body">
            <div class="shipment-upload-fields">
              <div class="shipment-upload-field-wrap">
                <label class="shipment-upload-label">Invoice Value</label>
                <v-text-field
                  v-model="invoiceValue"
                  :rules="[rules.required]"
                  placeholder="Enter invoice value"
                  outline
                  single-line
                  class="shipment-upload-input"
                ></v-text-field>
              </div>
              <div class="shipment-upload-field-wrap" v-if="currency == 'PKR'">
                <label class="shipment-upload-label">Invoice Number</label>
                <v-text-field
                  :rules="[rules.required, rules.noWhiteSpace]"
                  v-model="invoiceNumber"
                  placeholder="Enter invoice number"
                  outline
                  single-line
                  class="shipment-upload-input"
                ></v-text-field>
              </div>
              <div class="shipment-upload-field-wrap" v-else>
                <label class="shipment-upload-label">
                  Customer Reference Number
                </label>
                <v-text-field
                  :rules="[rules.required, rules.noWhiteSpace]"
                  v-model="invoiceNumber"
                  placeholder="Enter reference number"
                  outline
                  single-line
                  class="shipment-upload-input"
                ></v-text-field>
              </div>
              <div class="shipment-upload-field-wrap">
                <label class="shipment-upload-label">Weight (In Tonnes)</label>
                <v-text-field
                  v-model="weight"
                  placeholder="Enter weight"
                  outline
                  single-line
                  hide-details
                  type="number"
                  class="shipment-upload-input"
                ></v-text-field>
              </div>
            </div>

            <div
              class="shipment-upload-row"
              :key="i"
              v-for="(checklist, i) in shipmentDocument"
            >
              <div class="shipment-upload-type">
                <v-select
                  :items="documentType"
                  label="Select type"
                  item-text="documentName"
                  :rules="[rules.required]"
                  item-value="documentNumber"
                  v-model="checklist.documentNumber"
                  outline
                  single-line
                  class="shipment-upload-input"
                ></v-select>
              </div>
              <ul class="shipment-upload-files">
                <li
                  :key="j"
                  v-for="(doc, j) in checklist.document"
                  class="list"
                  ref="documentList"
                >
                  <button
                    type="button"
                    class="shipment-upload-file-remove"
                    v-show="document"
                    @click="removeImage(j, i)"
                  >
                    <span class="imageClose">&times;</span>
                  </button>
                  <a
                    :href="doc"
                    class="document-link"
                    v-if="doc.substr(doc.lastIndexOf('.') + 1) === 'pdf'"
                    target="_blank"
                  >
                    <img
                      src="../../assets/pfd.png"
                      height="40"
                      width="32"
                    />
                  </a>
                  <a
                    :href="doc"
                    class="document-link"
                    target="_blank"
                    v-else
                  >
                    <img
                      src="../../assets/docimg.webp"
                      height="40"
                      width="40"
                    />
                  </a>
                </li>
              </ul>
              <div class="shipment-upload-row-actions">
                <div
                  class="upload-btn-wrapper"
                  v-show="checklist.document.length < 5"
                >
                  <button type="button" class="btn">+ Upload</button>
                  <input
                    :disabled="processing"
                    :id="'fileUpload' + i"
                    :ref="'fileUpload' + i"
                    type="file"
                    accept=".pdf, .jpeg, .jpg, .png"
                    title="Choose a file to upload"
                    @change="uploadDocument($event, i)"
                  />
                </div>
                <div
                  class="upload-btn-wrapper"
                  v-if="shipmentDocument.length != 1"
                >
                  <button
                    class="btn shipment-upload-remove"
                    @click="close(i)"
                    type="button"
                  >
                    Remove
                  </button>
                </div>
              </div>
            </div>

            <div
              v-if="this.shipmentDocument.length <= 10"
              class="shipment-upload-add-wrap"
            >
              <button
                @click="addMore"
                class="btn shipment-upload-add"
                type="button"
              >
                + Add More
              </button>
            </div>

            <v-checkbox
              v-model="checkbox1"
              label="Documents shown to customer"
              class="shipment-upload-checkbox"
              hide-details
            ></v-checkbox>
            <small class="success" v-show="this.res">{{ this.res }}</small>
          </v-card-text>
          <v-card-actions class="shipment-upload-actions">
            <v-spacer></v-spacer>
            <v-btn class="shipment-upload-cancel-btn" @click="closeDialog()">
              Close
            </v-btn>
            <v-btn class="shipment-upload-save-btn" @click="addDocument">
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
      <!-- <ErrorBox :error="x.error" /> -->
      <v-snackbar
        :timeout="3000"
        bottom
        color="red darken-2"
        v-model="x.error"
        class="white--text"
        v-if="x.error"
        >{{ x.error }}</v-snackbar
      >
    </v-dialog>
  </div>
</template>
<script>
  import { StorageKeys } from "../../constants/constants";
  import ErrorBox from "@/components/Common/ErrorBox";
  import { jobDocument } from "../../constants/api-urls";
  export default {
    created() {
      this.customerStatus = localStorage.getItem("cust-status");
    },
    data() {
      return {
        operationName: "",
        customerStatus: "",
        checkbox1: false,
        document: [],
        documentType: [],
        valid: true,
        lazy: false,
        weight: "",
        index: 0,
        invoiceNumber: "",
        invoiceValue: "",
        shipmentDocument: [
          {
            i: 0,
            document: [],
            documentNumber: "",
          },
        ],
        res: "",
        dialog: false,
        selected: ["email"],
        message: null,
        loading: false,
        processing: false,
        x: {
          error: "",
        },
        rules: {
          noWhiteSpace: (v) =>
            (v != null && v.trim().length > 0) || "This field is required.",
          required: (value) => !!value || "This field is required.",
          requiredLength: (value) => !value.length || "This field is required.",
        },
      };
    },
    components: {
      ErrorBox,
    },
    props: ["assId", "status", "currency"],
    methods: {
      async check() {
        this.operationName = "add-documents-jobs";
        let y = await this.checkOpertaionPermission(this.operationName);
        if (y) {
          this.dialog = true;
          this.getShipmentType();
        } else {
          return;
        }
      },
      getShipmentType() {
        this.loading = true;
        let Url = jobDocument.getShipmentTypeForPopUP;
        delete this.axios.defaults.headers.common["token"];
        let token = localStorage.getItem(StorageKeys.SessionKey);
        let config = {
          headers: {
            authorization: `bearer ${token}`,
          },
        };

        let body = {
          assignmentId: this.$props.assId,
          skip: "0",
          limit: "15",
        };
        this.axios.post(this.constants.apiUrl + Url, body, config).then(
          (response) => {
            this.documentType = response.data.data.data;
            this.x.success = true;
            if (response.data.data.assginData.inoviceNumber) {
              this.invoiceNumber = response.data.data.assginData.inoviceNumber;
            }
            if (response.data.data.assginData.invoiceValue) {
              this.invoiceValue = response.data.data.assginData.invoiceValue;
            }
            this.weight = response.data.data.assginData.weight;
            this.loading = false;
            //this.$refs.form.resetValidation();
          },
          (error) => {
            this.success = false;
            this.loading = false;
            this.error = error.response.data.message;
            setTimeout(() => {
              this.error = "";
            }, 6000);
          }
        );
      },
      addMore() {
        let el = this.shipmentDocument.length;
        let checklist = {
          i: this.shipmentDocument[el - 1] + 1,
          documentNumber: null,
          document: [],
        };
        this.shipmentDocument.push(checklist);
      },
      closeDialog(i) {
        this.dialog = false;
        this.$refs.form.resetValidation();
        this.checkbox1 = false;
        this.shipmentDocument.splice(1, this.shipmentDocument.length);
        this.shipmentDocument = [
          {
            i: 0,
            document: [],
            documentNumber: "",
          },
        ];
      },
      close(i) {
        if (this.shipmentDocument.length == 1) {
          return;
        } else {
          let el = this.shipmentDocument;
          el.splice(i, 1);
          this.shipmentDocument = el;
        }
      },
      removeImage(key, i) {
        this.shipmentDocument[i].document.splice(key, 1);
      },
      uploadDocument(e, i) {
        if (this.processing) {
          return;
        } else {
          this.processing = true;
          this.loading = true;
          var files = e.target.files || e.dataTransfer.files;
          // $("#fileUpload")[0].value = '';

          if (!files.length) return;
          this.createImage(files[0], 1, i);
        }
      },
      createImage(file, status, i) {
        var temp = "fileUpload" + i;
        document.getElementById(temp).value = "";

        //this.$refs['fileUpload'+i].value = "";

        if (
          file.type
            .toString()
            .substr(file.type.toString().lastIndexOf(".") + 1) !==
            "image/png" &&
          file.type
            .toString()
            .substr(file.type.toString().lastIndexOf(".") + 1) !==
            "image/jpg" &&
          file.type
            .toString()
            .substr(file.type.toString().lastIndexOf(".") + 1) !==
            "image/jpeg" &&
          file.type
            .toString()
            .substr(file.type.toString().lastIndexOf(".") + 1) !==
            "application/pdf"
        ) {
          this.loading = false;
          this.x.error = "Please upload jpg/png/pdf file only!";

          this.processing = false;
          return false;
        } else {
          var image = new Image();
          var reader = new FileReader();
          var vm = this;

          reader.onload = (e) => {
            vm.image = e.target.result;
          };
          reader.readAsDataURL(file);
          this.upload(file, status, i);
        }
      },
      upload(file, statusChange, i) {
        this.loading = true;
        const formData = new FormData();
        formData.append("image", file);
        this.axios({
          url: `${this.constants.apiUrl}/dmsAdmin/uploadImage`,
          method: "POST",
          data: formData,
          headers: {
            Accept: "application/json",
            "Content-Type": "multipart/form-data",
          },
        }).then(
          (response) => {
            const status = response.status;
            const { imageUrl } = response.data;
            this.processing = false;
            if (status === 200) {
              this.loading = false;
              if (statusChange == 1) {
                //this.document.push(response.data.data.original);
                this.shipmentDocument[i].document.push(
                  response.data.data.original
                );
              }
            } else {
              this.x.error = "Failed to upload image";
            }
            this.loading = false;
          },
          (error) => {
            false;
            this.x.error = "Failed to upload image";
            this.loading = false;
          }
        );
      },
      async addDocument() {
        this.operationName = "add-documents-jobs";
        let y = await this.checkOpertaionPermission(this.operationName);
        if (y) {
          if (this.processing) {
            return;
          }
          const size = this.shipmentDocument.length;
          for (var n = 0; n < size; n++) {
            if (!this.shipmentDocument[n].document.length) {
              this.x.error = "Please upload shipment document";
              this.processing = false;
              this.loading = false;
              return false;
            }
          }
          if (this.$refs.form.validate()) {
            this.processing = true;
            let url = jobDocument.uploadShipmentDocument;
            delete this.axios.defaults.headers.common["token"];
            let token = localStorage.getItem(StorageKeys.SessionKey);
            let config = {
              headers: {
                authorization: `bearer ${token}`,
              },
            };
            let shipmentDocument1 = [];
            this.shipmentDocument.forEach((element) => {
              delete element["i"];
              shipmentDocument1.push(element);
            });
            let body = {
              assignmentId: this.assId,
              shipmentDocument: shipmentDocument1,
              invoiceValue: this.invoiceValue.toString(),
              inoviceNumber: this.invoiceNumber.toString(),
              documentShowToCustomer: this.checkbox1,
            };
            if (this.weight) {
              body.weight = this.weight;
            }
            this.axios.post(this.constants.apiUrl + url, body, config).then(
              (response) => {
                this.res = response.data.message;
                this.document = [];
                this.res = "";
                this.dialog = false;
                this.$refs.form.resetValidation();
                this.checkbox1 = false;
                this.shipmentDocument.splice(1, this.shipmentDocument.length);
                this.shipmentDocument = [
                  {
                    i: 0,
                    document: [],
                    documentNumber: "",
                  },
                ];
                this.processing = false;
                (this.checkbox1 = false), this.$emit("updateAssignment");
                this.$eventBus.$emit("success-shipment-doc");
                this.$eventBus.$emit("shpiment-dialog-close");
              },
              (error) => {
                this.processing = false;
                //this.dialog = true;
                this.x.error = error.response.data.message;
              }
            );
          } else {
            return;
          }
        }
      },
    },
  };
</script>
<style scoped>
  .success {
    font-size: 14px;
    font-weight: 600;
  }
  .list {
    display: inline-block;
    position: relative;
  }
  .imageClose {
    position: absolute;
    width: 16px;
    height: 16px;
    background: #000;
    border-radius: 50%;
    color: #fff !important;
    line-height: 16px;
    top: -4px;
    left: -4px;
    font-size: 12px;
  }
</style>

<style>
.application .v-dialog.job-documents-dialog.shipment-upload-dialog {
  max-inline-size: min(52rem, calc(100vw - 2rem)) !important;
  max-width: min(52rem, calc(100vw - 2rem)) !important;
  width: min(52rem, calc(100vw - 2rem)) !important;
}

/* No !important on display here: Vuetify closes the dialog with an inline
   display:none on .v-dialog, which an !important rule would override */
.application .v-dialog.shipment-upload-dialog,
.application .v-dialog.shipment-upload-dialog form,
.application .v-dialog.shipment-upload-dialog .shipment-upload-card {
  display: flex;
  flex-direction: column;
  max-height: min(82vh, 46rem);
  min-height: 0;
  overflow: hidden;
}

.application .v-dialog.shipment-upload-dialog form,
.application .v-dialog.shipment-upload-dialog .shipment-upload-card {
  display: flex !important;
}

.application .v-dialog.shipment-upload-dialog .shipment-upload-card {
  background: #ffffff !important;
  border-radius: 1rem !important;
  box-shadow: 0 1.25rem 2.5rem rgba(28, 43, 95, 0.14) !important;
  width: 100%;
}

.application .v-dialog.shipment-upload-dialog .shipment-upload-header {
  align-items: center;
  background: #fff7ed !important;
  border-bottom: 0.0625rem solid #fed7aa;
  display: flex;
  flex: 0 0 auto;
  gap: 0.75rem;
  justify-content: space-between;
  min-height: 3rem;
  padding: 0.75rem 1rem !important;
}

.application .v-dialog.shipment-upload-dialog .shipment-upload-title {
  color: #1c2b5f !important;
  font-size: 0.975rem !important;
  font-weight: 800 !important;
  letter-spacing: -0.01em;
  line-height: 1.25;
  margin: 0;
}

.application .v-dialog.shipment-upload-dialog .shipment-upload-close {
  height: 1.75rem !important;
  margin: 0 !important;
  width: 1.75rem !important;
}

.application .v-dialog.shipment-upload-dialog .shipment-upload-close .v-icon {
  color: #3a382f !important;
  font-size: 1.25rem !important;
}

.application .v-dialog.shipment-upload-dialog .shipment-upload-body {
  background: #ffffff;
  flex: 1 1 auto;
  max-height: none !important;
  min-height: 0;
  overflow: auto;
  padding: 1.25rem 1.25rem 0.75rem !important;
}

.application .v-dialog.shipment-upload-dialog .shipment-upload-fields {
  display: grid;
  gap: 0.75rem 1rem;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  margin-bottom: 1.25rem;
}

.application .v-dialog.shipment-upload-dialog .shipment-upload-field-wrap {
  min-width: 0;
}

.application .v-dialog.shipment-upload-dialog .shipment-upload-label {
  color: #3a382f;
  display: block;
  font-size: 0.75rem;
  font-weight: 800;
  line-height: 1.3;
  margin-bottom: 0.375rem;
}

.application .v-dialog.shipment-upload-dialog .shipment-upload-input {
  margin: 0 !important;
  padding-top: 0 !important;
}

.application .v-dialog.shipment-upload-dialog .shipment-upload-input .v-input__control {
  min-height: 2.5rem;
}

.application .v-dialog.shipment-upload-dialog .shipment-upload-field-wrap .v-label {
  display: none !important;
}

.application .v-dialog.shipment-upload-dialog .shipment-upload-type .v-label {
  font-size: 0.8125rem !important;
  height: 2.5rem !important;
  left: 0.75rem !important;
  line-height: 2.5rem !important;
  max-width: calc(100% - 2.5rem);
  overflow: hidden;
  pointer-events: none;
  text-overflow: ellipsis;
  top: 0 !important;
  transform: none !important;
  white-space: nowrap;
}

.application .v-dialog.shipment-upload-dialog .shipment-upload-type .v-input--is-label-active .v-label,
.application .v-dialog.shipment-upload-dialog .shipment-upload-type .v-input--is-dirty .v-label {
  display: none !important;
}

/* Only take up space for a validation message when there is one */
.application .v-dialog.shipment-upload-dialog .shipment-upload-input .v-text-field__details {
  margin-bottom: 0 !important;
  min-height: 0 !important;
}

.application .v-dialog.shipment-upload-dialog .shipment-upload-input .v-messages {
  min-height: 0 !important;
}

.application .v-dialog.shipment-upload-dialog .shipment-upload-input .v-messages__message {
  padding-top: 0.25rem;
}

.application .v-dialog.shipment-upload-dialog .shipment-upload-input .v-input__slot::before,
.application .v-dialog.shipment-upload-dialog .shipment-upload-input .v-input__slot::after {
  display: none !important;
}

.application .v-dialog.shipment-upload-dialog .shipment-upload-input .v-input__slot {
  align-items: center;
  background: #ffffff !important;
  border: 0.0625rem solid #e4e1d9 !important;
  border-radius: 0.5rem !important;
  box-shadow: none !important;
  min-height: 2.5rem !important;
  padding: 0 0.75rem !important;
}

.application .v-dialog.shipment-upload-dialog .shipment-upload-input.v-input--is-focused .v-input__slot {
  border-color: #ea7a1c !important;
  box-shadow: 0 0 0 0.1875rem rgba(234, 122, 28, 0.12) !important;
}

.application .v-dialog.shipment-upload-dialog .shipment-upload-input input,
.application .v-dialog.shipment-upload-dialog .shipment-upload-input .v-select__selections {
  margin-top: 0 !important;
  padding: 0 !important;
}

.application .v-dialog.shipment-upload-dialog .shipment-upload-input input::placeholder {
  color: #8a857c !important;
  opacity: 1;
}

.application .v-dialog.shipment-upload-dialog .shipment-upload-input .v-input__append-inner,
.application .v-dialog.shipment-upload-dialog .shipment-upload-input .v-input__icon {
  align-self: center;
  height: 2.5rem;
  margin: 0 !important;
}

/* Top-align: the select reserves space for its validation message below the
   2.5rem control, so centring would push the files/buttons off its middle */
.application .v-dialog.shipment-upload-dialog .shipment-upload-row {
  align-items: flex-start;
  display: flex;
  gap: 0.75rem;
  margin-bottom: 0.75rem;
  min-width: 0;
}

.application .v-dialog.shipment-upload-dialog .shipment-upload-type {
  flex: 0 0 14rem;
  max-width: 16rem;
  min-width: 12rem;
}

.application .v-dialog.shipment-upload-dialog .shipment-upload-files {
  align-items: center;
  display: flex;
  flex: 1 1 auto;
  flex-wrap: wrap;
  gap: 0.5rem;
  list-style: none;
  margin: 0 !important;
  min-height: 2.5rem;
  min-width: 0;
  padding: 0 !important;
}

.application .v-dialog.shipment-upload-dialog .shipment-upload-files .list {
  background: transparent !important;
  border: 0 !important;
  display: inline-block;
  padding: 0 !important;
  position: relative;
}

.application .v-dialog.shipment-upload-dialog .shipment-upload-file-remove {
  background: transparent;
  border: 0;
  cursor: pointer;
  padding: 0;
}

/* Beats the global .document-link img preview (cover crop, heavy border) */
.application .v-dialog.shipment-upload-dialog .shipment-upload-files .list .document-link img {
  background: #ffffff !important;
  border: 1px solid #e4e1d9 !important;
  border-radius: 0.5rem !important;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.06) !important;
  display: block !important;
  filter: none !important;
  height: 2.5rem !important;
  margin: 0 !important;
  min-height: 0 !important;
  min-width: 0 !important;
  object-fit: contain !important;
  padding: 0.3125rem !important;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
  width: 2.5rem !important;
}

.application .v-dialog.shipment-upload-dialog .shipment-upload-files .list .document-link:hover img {
  border-color: #ea7a1c !important;
  box-shadow: 0 0 0 3px rgba(234, 122, 28, 0.12) !important;
}

/* Beats the global dark-brown .imageClose badge */
.application .v-dialog.shipment-upload-dialog .shipment-upload-files .list > .shipment-upload-file-remove[type="button"] .imageClose {
  background: #ffffff !important;
  border: 1px solid #e4e1d9 !important;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.16) !important;
  color: #5b6475 !important;
  font-size: 13px !important;
  font-weight: 600 !important;
  height: 18px !important;
  right: -7px !important;
  top: -7px !important;
  width: 18px !important;
}

.application .v-dialog.shipment-upload-dialog .shipment-upload-files .list > .shipment-upload-file-remove[type="button"]:hover .imageClose,
.application .v-dialog.shipment-upload-dialog .shipment-upload-files .list > .shipment-upload-file-remove[type="button"]:focus-visible .imageClose {
  background: #fee4e2 !important;
  border-color: #fda29b !important;
  box-shadow: 0 1px 3px rgba(217, 45, 32, 0.2) !important;
  color: #d92d20 !important;
  transform: none !important;
}

.application .v-dialog.shipment-upload-dialog .shipment-upload-row-actions {
  align-items: center;
  display: flex;
  flex: 0 0 auto;
  gap: 0.5rem;
  min-height: 2.5rem;
}

.application .v-dialog.shipment-upload-dialog .upload-btn-wrapper {
  display: inline-flex;
  overflow: hidden;
  position: relative;
}

.application .v-dialog.shipment-upload-dialog .upload-btn-wrapper input[type="file"] {
  cursor: pointer;
  font-size: 100px;
  height: 100%;
  left: 0;
  opacity: 0;
  position: absolute;
  top: 0;
  width: 100%;
}

.application .v-dialog.shipment-upload-dialog .upload-btn-wrapper .btn,
.application .v-dialog.shipment-upload-dialog .shipment-upload-add {
  align-items: center;
  background: #fff7ed !important;
  border: 0.0625rem solid #fed7aa !important;
  border-radius: 0.5rem !important;
  color: #a85510 !important;
  cursor: pointer;
  display: inline-flex;
  font-size: 0.75rem !important;
  font-weight: 800 !important;
  justify-content: center;
  min-height: 2.5rem;
  padding: 0 0.875rem !important;
  white-space: nowrap;
}

.application .v-dialog.shipment-upload-dialog .shipment-upload-remove {
  background: #fff7ed !important;
  border-color: #fed7aa !important;
  color: #a85510 !important;
}

.application .v-dialog.shipment-upload-dialog .shipment-upload-add-wrap {
  margin: 0 0 1rem;
}

.application .v-dialog.shipment-upload-dialog .shipment-upload-checkbox {
  margin: 0 0 0.5rem !important;
  padding-top: 0 !important;
}

.application .v-dialog.shipment-upload-dialog .shipment-upload-checkbox .v-input__slot {
  align-items: center;
  border: 0 !important;
  box-shadow: none !important;
  min-height: auto !important;
}

.application .v-dialog.shipment-upload-dialog .shipment-upload-checkbox .v-label {
  color: #3a382f !important;
  display: inline !important;
  font-size: 0.8125rem !important;
  font-weight: 600;
}

.application .v-dialog.shipment-upload-dialog .shipment-upload-actions {
  background: #ffffff;
  border-top: 0.0625rem solid #e4e1d9;
  flex: 0 0 auto;
  gap: 0.5rem;
  justify-content: flex-end;
  padding: 0.75rem 1.25rem !important;
}

.application .v-dialog.shipment-upload-dialog .shipment-upload-cancel-btn.v-btn,
.application .v-dialog.shipment-upload-dialog .shipment-upload-save-btn.v-btn {
  border-radius: 0.5rem !important;
  box-shadow: none !important;
  font-weight: 800 !important;
  height: 2.25rem !important;
  letter-spacing: 0 !important;
  margin: 0 !important;
  min-width: 5.5rem !important;
  text-transform: none !important;
}

.application .v-dialog.shipment-upload-dialog .shipment-upload-cancel-btn.v-btn {
  background: #ffffff !important;
  border: 0.0625rem solid #e4e1d9 !important;
  color: #3a382f !important;
}

.application .v-dialog.shipment-upload-dialog .shipment-upload-save-btn.v-btn {
  background: #ea7a1c !important;
  border: 0.0625rem solid #ea7a1c !important;
  color: #ffffff !important;
}

.application .v-dialog.shipment-upload-dialog .shipment-upload-save-btn.v-btn .v-btn__content {
  color: #ffffff !important;
}

@media (max-width: 720px) {
  .application .v-dialog.shipment-upload-dialog .shipment-upload-fields {
    grid-template-columns: 1fr;
  }

  .application .v-dialog.shipment-upload-dialog .shipment-upload-row {
    align-items: stretch;
    flex-wrap: wrap;
  }

  .application .v-dialog.shipment-upload-dialog .shipment-upload-type {
    flex: 1 1 100%;
    max-width: none;
  }

  .application .v-dialog.shipment-upload-dialog .shipment-upload-files {
    flex: 1 1 100%;
  }
}
</style>
